import { useContext } from "react";
import { AppContext } from "../App";
import { formatMoney, getCdnUrl, parseJson } from "../Helpers";

export default function RequestedServiceCard({ item }) {
  const appContext = useContext(AppContext);
  const snapshot = parseJson(item.serviceSnapshot, {});
  const title = appContext.language === "sw" ? item.titleSw || item.titleEn : item.titleEn;
  const resultOptions = snapshot.resultOptions || [];
  const outcome = resultOptions.find((option) => option.value === item.resultOutcome);

  function openPayments() {
    appContext.navTo({ item: 'side-view', subItem: 'requested-service-payment-options', extraItem: item.uuid });
  }

  return (
    <div className="card mb-3">
      <div className="card-body">
        <div className="d-flex justify-content-between align-items-start">
          <div>
            <h6 className="font-semi-bold mb-1">{title}</h6>
            <span className="badge bg-light text-dark me-2">{item.serviceType}</span>
            <span className="badge bg-dark">{String(item.processingStatus).replace("_", " ")}</span>
          </div>
          <h6 className="font-bold text-primary">TZS {formatMoney(item.quotedAmount)}</h6>
        </div>

        <div className="row mt-3" style={{ fontSize: "13px" }}>
          <div className="col-6 mb-2"><span className="text-muted">Paid</span><br />TZS {formatMoney(item.paidAmount)}</div>
          <div className="col-6 mb-2"><span className="text-muted">Balance</span><br />TZS {formatMoney(item.balanceAmount)}</div>
          <div className="col-6 mb-2"><span className="text-muted">Payment status</span><br />{item.paymentStatus}</div>
          <div className="col-6 mb-2"><span className="text-muted">Required to start</span><br />TZS {formatMoney(item.amountRequiredToStart)}</div>
        </div>

        <button className="btn btn-sm btn-primary mt-2" onClick={openPayments}>
          {appContext.language === 'sw' ? 'Angalia na ulipe huduma' : 'View service and payments'}
        </button>

        {item.resultStatus === "published" ? (
          <div className="mt-3 border-top pt-3">
            <h6 className="font-semi-bold">Result</h6>
            {outcome ? <p className="mb-2"><span className="text-muted">Outcome:</span> {appContext.language === "sw" ? outcome.titleSw : outcome.titleEn}</p> : null}
            {item.resultDescription ? <p>{item.resultDescription}</p> : null}
            {(item.attachments || []).map((attachment) => (
              <a
                className="btn btn-sm btn-outline-primary me-2 mb-2"
                href={getCdnUrl(attachment.fileUrl)}
                target="_blank"
                rel="noreferrer"
                key={attachment.uuid}
              >
                {attachment.originalName || "Open attachment"}
              </a>
            ))}
          </div>
        ) : null}
      </div>
    </div>
  );
}
